export const TRIGGERS_LOAD = 'TRIGGERS_LOAD';
export const TRIGGERS_LOAD_SUCCESS = 'TRIGGERS_LOAD_SUCCESS';
export const TRIGGERS_LOAD_ERROR = 'TRIGGERS_LOAD_ERROR';

export const TRIGGERS_ADD = 'TRIGGERS_ADD';
export const TRIGGERS_ADD_SUCCESS = 'TRIGGERS_ADD_SUCCESS';
export const TRIGGERS_ADD_ERROR = 'TRIGGERS_ADD_ERROR';
export const TRIGGERS_UPDATE = 'TRIGGERS_UPDATE';
export const TRIGGERS_UPDATE_SUCCESS = 'TRIGGERS_UPDATE_SUCCESS';
export const TRIGGERS_UPDATE_ERROR = 'TRIGGERS_UPDATE_ERROR';
export const TRIGGERS_DELETE = 'TRIGGERS_DELETE';
export const TRIGGERS_DELETE_SUCCESS = 'TRIGGERS_DELETE_SUCCESS';
export const TRIGGERS_DELETE_ERROR = 'TRIGGERS_DELETE_ERROR';

export const TRIGGER_ADD = 'TRIGGER_ADD';
export const TRIGGER_ADD_SUCCESS = 'TRIGGER_ADD_SUCCESS';
export const TRIGGER_ADD_ERROR = 'TRIGGER_ADD_ERROR';
export const TRIGGER_UPDATE = 'TRIGGER_UPDATE';
export const TRIGGER_UPDATE_SUCCESS = 'TRIGGER_UPDATE_SUCCESS';
export const TRIGGER_UPDATE_ERROR = 'TRIGGER_UPDATE_ERROR';
export const TRIGGER_DELETE = 'TRIGGER_DELETE';
export const TRIGGER_DELETE_SUCCESS = 'TRIGGER_DELETE_SUCCESS';
export const TRIGGER_DELETE_ERROR = 'TRIGGER_DELETE_ERROR';
